import ServiceLocator from "../../ServiceLocator";
import Player from "./Player";
import SpecialCardAnimation from "./SpecialCardAnimation";

import * as PIXI from "pixi.js";
import gsap from "gsap";


export default class SkipAnimation extends SpecialCardAnimation
{
    private _nextPlayer: Player = null;

    private _iconWrapper: PIXI.Container = null;
    private _iconShadow: PIXI.Sprite = null;
    private _icon: PIXI.Sprite = null;

    public set nextPlayer( value: Player ) { this._nextPlayer = value; }


    public constructor()
    {
        super();
    }

    public init(): void
    {
        super.init();

        console.assert( this._nextPlayer != null, "SkipAnimation.ts : init() :: this._nextPlayer cannot be null." );

        this._bannerText.text = "SKIP";
        this._bannerText.style.fill = this._kArrHexColor[ this._color ];

        this._iconWrapper = new PIXI.Container();
        this._iconWrapper.visible = false;
        this.addChild( this._iconWrapper );
        //
        this._iconShadow = new PIXI.Sprite( ServiceLocator.resources.special_icon_skip_shadow.texture );
        this._iconShadow.anchor.set( 0.5 );
        this._iconShadow.position.set( -30.5 * 0.5, 32.5 * 0.5 );
        this._iconWrapper.addChild( this._iconShadow );
        //
        this._icon = new PIXI.Sprite( ServiceLocator.resources[ "special_icon_skip_" + [ "red", "yellow", "blue", "green" ][ this._color ] ].texture );
        this._icon.anchor.set( 0.5 );
        this._iconWrapper.addChild( this._icon );
    }

    public end(): void
    {
        super.end();

        // TODO:
    }

    /*public play(): void
    {
        const kPlayerTargetPos: PIXI.Point = this.toLocal( this._nextPlayer.portraitGlobalPos );
        this._banner.visible = true;
        this._glow.visible = true;
        this._icon.visible = true;
        this._iconShadow.visible = true;
        this._iconShadow.alpha = 0;

        this._tl = new gsap.core.Timeline();
        this._tl.from( this._banner.scale, { y: 0, duration: 0.2, ease: "sine.in" }, 0 );
        this._tl.from( this._glow, { alpha: 0, duration: 0.2, ease: "sine.in" }, "<" );
        this._tl.from( this._icon.scale, { x: 2, y: 2, duration: 0.2, ease: "linear.inOut" }, "<" );
        this._tl.from( this._iconShadow, { x: "-=60", duration: 0.2, ease: "sine.in" }, "<" );
        this._tl.to( this._iconShadow, { alpha: 1, duration: 0.2, ease: "sine.in" }, "<" );
        this._tl.to( this._icon, { angle: 360, duration: 0.4, ease: "sine.inOut" }, 0.6 );
        this._tl.to( this._iconShadow, { angle: 360, duration: 0.4, ease: "sine.inOut" }, "<" );
        this._tl.to( this._iconWrapper, { x: kPlayerTargetPos.x, y: kPlayerTargetPos.y, duration: 0.4, ease: "sine.in" }, 1 );
        this._tl.to( this._iconWrapper.scale, { x: 0.4, y: 0.4, duration: 0.4, ease: "sine.in" }, "<" );
        this._tl.to( this._glow, { alpha: 0, duration: 0.2, ease: "sine.in" }, "<" );
        this._tl.to( this._banner.scale, { y: 0, duration: 0.2, ease: "sine.in" }, "<" );
        this._tl.to( this._iconWrapper.scale, { x: 0.5, y: 0.5, duration: 0.1, ease: "sine.out" }, 1.4 );
        this._tl.to( this._iconWrapper.scale, { x: 0.4, y: 0.4, duration: 0.1, ease: "sine.in" }, ">" );
        this._tl.call( () => { this._onCompleted.dispatch(); }, null, 1.8 );
        //
        ServiceLocator.game.tweenGroup.add( this._tl );
    }*/

    public play(): void
    {
        this._iconWrapper.visible = true;
        this._iconWrapper.scale.set( 0 );
        const kPlayerTargetPos: PIXI.Point = this.toLocal( this._nextPlayer.portraitGlobalPos );
        this._iconWrapper.position.copyFrom( kPlayerTargetPos );
        
        this._tl = new gsap.core.Timeline();
        this._tl.to( this._iconWrapper.scale, { x: 0.4, y: 0.4, duration: 0.2, ease: "back.out" } );
        this._tl.to( this._iconWrapper, { alpha: 0, duration: 0.6, ease: "sine.in" }, 0.6 );
        this._tl.call( () => { this._onCompleted.dispatch(); } );
        //
        ServiceLocator.game.tweenGroup.add( this._tl );

        ServiceLocator.audio.playSfx( "skip_special" );
    }
}